import PropTypes from "prop-types";
import {
  Overlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalMessage,
  ModalFooter,
  SecondaryButton,
  PrimaryButton,
} from "./styles";

const UIWidgetsModal = ({
  isOpen,
  title = "Confirm",
  message = "Are you sure?",
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  onClose,
  onConfirm,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <ModalCloseButton onClick={onClose} aria-label="Close">
            &#x2715;
          </ModalCloseButton>
        </ModalHeader>
        <ModalBody>
          <ModalMessage>{message}</ModalMessage>
        </ModalBody>
        <ModalFooter>
          <SecondaryButton onClick={onClose}>{cancelLabel}</SecondaryButton>
          <PrimaryButton onClick={onConfirm}>{confirmLabel}</PrimaryButton>
        </ModalFooter>
      </ModalContainer>
    </Overlay>
  );
};

UIWidgetsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default UIWidgetsModal;
